// AddProducts.jsx
import "./AddProducts.scss";
import React, { useState, useEffect, useRef } from "react";
import CustomDatePicker from "./CustomDatePicker";

function AddProducts() {
  const [categoryVal, setCategoryVal] = useState("");
  const [productNameVal, setProductNameVal] = useState("");
  const [manufacturerVal, setManufacturerVal] = useState("");
  const [animeSeriesVal, setAnimeSeriesVal] = useState("");
  const [productTypeVal, setProductTypeVal] = useState("ON HAND");
  const [origPriceVal, setOrigPriceVal] = useState("");
  const [salePriceVal, setSalePriceVal] = useState("");
  const [stockVal, setStockVal] = useState("");
  const [japanEstDate, setJapanEstDate] = useState("");
  const [preOrderDeadlineVal, setpreOrderDeadlineVal] = useState("");
  const [downPaymentVal, setDownPaymentVal] = useState("");

  const [isProductTypeDDShow, setProductTypeDDShow] = useState(false);
  const [isCategoryDDShow, setCategoryDDShow] = useState(false);
  const [isManufacturerDDShow, setManufacturerDDShow] = useState(false);
  const [isAnimeSeriesDDShow, setAnimeSeriesDDShow] = useState(false);

  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [productImages, setProductImages] = useState([]);

  const [categories, setCategories] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [animeSeries, setAnimeSeries] = useState([]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Handle selecting files
  const handleSelectImages = () => fileInputRef.current.click();

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const validFiles = files.filter((file) => {
      const isValidType = ["image/jpeg", "image/jpg", "image/png"].includes(
        file.type
      );
      return isValidType; // Only check type, no size limit
    });

    const limitedFiles = validFiles.slice(0, 6); // keep max 6 files

    const imagePreviews = limitedFiles.map((file) => URL.createObjectURL(file));

    setSelectedFiles(limitedFiles);
    setProductImages(imagePreviews);
  };
  // Fetch dropdowns
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/product/add-get-foreign`
        );
        const data = await res.json();
        setCategories(data.categories);
        setManufacturers(data.manufacturers);
        setAnimeSeries(data.animeSeries);
      } catch (err) {
        console.error("Failed to fetch dropdown data", err);
      }
    };
    fetchDropdowns();
  }, []);

  // Form validation
  const validateForm = () => {
    let newErrors = {};

    if (!categoryVal) newErrors.categoryVal = "Category is required";
    if (!productNameVal) newErrors.productNameVal = "Product Name is required";
    if (!manufacturerVal)
      newErrors.manufacturerVal = "Manufacturer is required";
    if (!animeSeriesVal) newErrors.animeSeriesVal = "Anime Series is required"; // validation added
    if (!origPriceVal) newErrors.origPriceVal = "Original Price is required";

    if (productTypeVal === "ON HAND") {
      if (!salePriceVal) newErrors.salePriceVal = "Sales Price is required";
      if (!stockVal) newErrors.stockVal = "Stock is required";
    } else {
      if (!preOrderDeadlineVal)
        newErrors.preOrderDeadlineVal = "Pre-order Deadline is required";
      if (!japanEstDate)
        newErrors.japanEstDate = "Japan Release Date is required";
    }

    if (!downPaymentVal) newErrors.downPaymentVal = "Downpayment is required";

    if (!selectedFiles || selectedFiles.length === 0) {
      newErrors.productImages = "At least 1 image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Save product
  const handleSave = async () => {
    if (!validateForm()) return;
    setLoading(true);

    // convert name -> ID
    const categoryObj = categories.find((c) => c.PC_Name === categoryVal);
    const manufacturerObj = manufacturers.find(
      (m) => m.PM_Name === manufacturerVal
    );
    const animeObj = animeSeries.find((a) => a.AS_Name === animeSeriesVal);

    try {
      const formData = new FormData();
      formData.append("subFolderName", productNameVal);
      formData.append("PC_ID", categoryObj?.PC_ID || null);
      formData.append("PD_Name", productNameVal);
      formData.append("PM_ID", manufacturerObj?.PM_ID || null);
      formData.append("AS_ID", animeObj?.AS_ID || null);
      formData.append("PD_ProductType", productTypeVal);
      formData.append("PD_OriginalPrice", origPriceVal);
      formData.append("PD_SalePrice", salePriceVal);
      formData.append("PD_Stock", stockVal);
      formData.append("PD_JapanEst", japanEstDate);
      formData.append("PD_PreOrderDeadline", preOrderDeadlineVal);
      formData.append("PD_DownPayment", downPaymentVal);

      selectedFiles.forEach((file) => {
        formData.append("PD_ProductPicPath", file);
      });

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/product/add-product`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (res.ok) {
        alert("Product saved successfully!");
        handleCancel();
        // reset form
      } else {
        alert("Failed to save product.");
      }
    } catch (err) {
      console.error("Error saving product", err);
      alert("Error saving product.");
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    setCategoryVal("");
    setProductNameVal("");
    setManufacturerVal("");
    setAnimeSeriesVal("");
    setProductTypeVal("ON HAND");
    setOrigPriceVal("");
    setSalePriceVal("");
    setStockVal("");
    setJapanEstDate("");
    setpreOrderDeadlineVal("");
    setDownPaymentVal("");
    setProductImages([]);
    setSelectedFiles([]);
    setErrors({});
    if (fileInputRef.current) fileInputRef.current.value = ""; // clear input
  };

  return (
    <div className="ap-container">
      {/* First row: left & right columns */}
      <div className="ap-first-row">
        <div className="ap-first-col">
          {/* Category */}
          <div className="ap-input-wrapper">
            <label className="ap-input-label">Category:</label>
            <input
              type="text"
              value={categoryVal}
              onFocus={() => setCategoryDDShow(true)}
              onBlur={() => setTimeout(() => setCategoryDDShow(false), 150)}
              readOnly
              style={{ cursor: "pointer" }}
            />
            {errors.categoryVal && (
              <span className="ap-error">{errors.categoryVal}</span>
            )}
            {isCategoryDDShow && (
              <div className="ap-dropdown">
                {categories.map((item) => (
                  <div
                    key={item.PC_ID}
                    className="ap-dropdown-items"
                    onClick={() => setCategoryVal(item.PC_Name)}
                  >
                    {item.PC_Name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Product Name */}
          <div className="ap-input-wrapper">
            <label className="ap-input-label">Product Name:</label>
            <input
              type="text"
              value={productNameVal}
              onChange={(e) => setProductNameVal(e.target.value)}
            />
            {errors.productNameVal && (
              <span className="ap-error">{errors.productNameVal}</span>
            )}
          </div>

          {/* Manufacturer */}
          <div className="ap-input-wrapper">
            <label className="ap-input-label">Manufacturer:</label>
            <input
              type="text"
              value={manufacturerVal}
              onFocus={() => setManufacturerDDShow(true)}
              onBlur={() => setTimeout(() => setManufacturerDDShow(false), 150)}
              readOnly
              style={{ cursor: "pointer" }}
            />
            {errors.manufacturerVal && (
              <span className="ap-error">{errors.manufacturerVal}</span>
            )}
            {isManufacturerDDShow && (
              <div className="ap-dropdown">
                {manufacturers.map((item) => (
                  <div
                    key={item.PM_ID}
                    className="ap-dropdown-items"
                    onClick={() => setManufacturerVal(item.PM_Name)}
                  >
                    {item.PM_Name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Anime Series */}
          <div className="ap-input-wrapper">
            <label className="ap-input-label">Anime Series:</label>
            <input
              type="text"
              value={animeSeriesVal}
              onFocus={() => setAnimeSeriesDDShow(true)}
              onBlur={() => setTimeout(() => setAnimeSeriesDDShow(false), 150)}
              readOnly
              style={{ cursor: "pointer" }}
            />
            {errors.animeSeriesVal && (
              <span className="ap-error">{errors.animeSeriesVal}</span>
            )}
            {isAnimeSeriesDDShow && (
              <div className="ap-dropdown">
                {animeSeries.map((item) => (
                  <div
                    key={item.AS_ID}
                    className="ap-dropdown-items"
                    onClick={() => setAnimeSeriesVal(item.AS_Name)}
                  >
                    {item.AS_Name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Product Type */}
          <div className="ap-input-wrapper">
            <label className="ap-input-label">Product Type:</label>
            <input
              type="text"
              value={productTypeVal}
              onFocus={() => setProductTypeDDShow(true)}
              onBlur={() => setTimeout(() => setProductTypeDDShow(false), 150)}
              readOnly
              style={{ cursor: "pointer" }}
            />
            {errors.productTypeVal && (
              <span className="ap-error">{errors.productTypeVal}</span>
            )}
            {isProductTypeDDShow && (
              <div className="ap-dropdown">
                {["ON HAND", "PRE-ORDER"].map((type) => (
                  <div
                    key={type}
                    className="ap-dropdown-items"
                    onClick={() => {
                      setProductTypeVal(type);
                      setProductTypeDDShow(false);
                    }}
                  >
                    {type}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Right column */}
        <div className="ap-first-col">
          {/* Original Price */}
          <div className="ap-input-wrapper">
            <label className="ap-input-label">Original Price:</label>
            <input
              type="text"
              value={origPriceVal}
              onChange={(e) => setOrigPriceVal(e.target.value)}
            />
            {errors.origPriceVal && (
              <span className="ap-error">{errors.origPriceVal}</span>
            )}
          </div>

          {/* Conditional fields */}
          {productTypeVal === "ON HAND" ? (
            <>
              <div className="ap-input-wrapper">
                <label className="ap-input-label">Sales Price:</label>
                <input
                  type="text"
                  value={salePriceVal}
                  onChange={(e) => setSalePriceVal(e.target.value)}
                />
                {errors.salePriceVal && (
                  <span className="ap-error">{errors.salePriceVal}</span>
                )}
              </div>

              <div className="ap-input-wrapper">
                <label className="ap-input-label">Number of Stock:</label>
                <input
                  type="text"
                  value={stockVal}
                  onChange={(e) => setStockVal(e.target.value)}
                />
                {errors.stockVal && (
                  <span className="ap-error">{errors.stockVal}</span>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="ap-input-wrapper">
                <label className="ap-input-label">Pre-Order Deadline:</label>
                <CustomDatePicker
                  date={preOrderDeadlineVal}
                  setDate={setpreOrderDeadlineVal}
                />
                {errors.preOrderDeadlineVal && (
                  <span className="ap-error">{errors.preOrderDeadlineVal}</span>
                )}
              </div>

              <div className="ap-input-wrapper">
                <label className="ap-input-label">
                  Japan Estimated Release Date:
                </label>
                <input
                  type="text"
                  value={japanEstDate}
                  onChange={(e) => setJapanEstDate(e.target.value)}
                />
                {errors.japanEstDate && (
                  <span className="ap-error">{errors.japanEstDate}</span>
                )}
              </div>
            </>
          )}

          {/* Downpayment */}
          <div className="ap-input-wrapper">
            <label className="ap-input-label">Downpayment:</label>
            <input
              type="text"
              value={downPaymentVal}
              onChange={(e) => setDownPaymentVal(e.target.value)}
            />
            {errors.downPaymentVal && (
              <span className="ap-error">{errors.downPaymentVal}</span>
            )}
          </div>

          {/* Images */}
          <div className="ap-input-wrapper">
            <button onClick={handleSelectImages}>UPLOAD IMAGES</button>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept=".jpg,.jpeg,.png"
              multiple
              onChange={handleFileChange}
            />
            <p>FILE EXTENSION: .JPG, .JPEG, .PNG</p>
            {errors.productImages && (
              <span className="ap-error">{errors.productImages}</span>
            )}
          </div>
        </div>
      </div>

      {/* Image preview */}
      <div className="ap-image-col">
        <div className="ap-image-col-wrapper">
          {productImages.length > 0
            ? productImages.map((img, index) => (
                <img key={index} src={img} alt={`Preview ${index}`} />
              ))
            : "Image Preview"}
        </div>
      </div>

      {/* Buttons */}
      <div className="ap-first-row">
        <div className="ap-btn-action-wrapper">
          <button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="save-btn" onClick={handleSave} disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddProducts;
